<template>
    <div class="row">
       <div class="mx-auto col-md-12">               
            <div class="card p-3 mb-3">
                <div class="card-body">
                    <b-card
                        class="mb-2"
                        header="Importação de Arquivo de contas criadas"
                        header-tag="header">
                            <div class="p-0 mb-3 col-12 d-md-flex">
                                <label class="col-md-1 p-1" for="arquivo">Arquivo</label>
                                <b-form-file		
                                    id="arquivo" 
                                    @input="inputArquivo" 	
                                    v-model="arquivo" 
                                    :accept="extPermitidasArquivo.toString()" 					
                                    placeholder="Clique para inserir um arquivo"                           
                                ></b-form-file>
                            </div>
                            <div class="p-0 col-12 text-right">
                                <b-button            
                                    @click="importar"
                                    :disabled="!arquivo"                                                                 
                                    variant="primary" >
                                        <font-awesome-icon
                                            :icon="['fas','file-import']"
                                            title="Importar Arquivo"
                                        /> Importar
                                </b-button>
                            </div>    
                    </b-card>           
                    <b-card
                        v-if="exibirResultadoImportacao"
                        class="mb-2"
                        header="Resultado da Importação"
                        header-tag="header">

                        <b-row align-v="start" class="infoImportacao mb-4">
                            <b-col class="item" cols="auto">
                                <span class="label">Arquivo: </span>{{this.nomeArquivo}}
                            </b-col>
                            <b-col class="item" cols="4">
                                <span class="label">Data da importação: </span>{{this.dataImportacao}}
                            </b-col>
                        </b-row>

                        <b-row class="justify-content-md-center mx-0 mb-4">
                            <b-list-group horizontal >
                                <b-list-group-item>Total de registros:
                                    <b-badge variant="primary">{{totaisRegistros.numeroRegistros}}</b-badge>
                                </b-list-group-item>
                                <b-list-group-item>Registros importados com sucesso:
                                    <b-badge variant="success">{{totaisRegistros.importadosComSucesso}}</b-badge>
                                </b-list-group-item>
                                <b-list-group-item>Registros com erro:
                                    <b-badge variant="danger">{{totaisRegistros.erros}}</b-badge>
                                </b-list-group-item>
                            </b-list-group>
                        </b-row>

                        <div v-if="totaisRegistros.erros > 0">
                            <b-row>
                                <b-col>
                                    <span class="px-0 col-12 font-weight-bold">Log de registros com erros</span>
                                </b-col>
                                <b-col class="text-right">
                                    <b-button
                                        @click="gerarLogTXT"                                  
                                        variant="primary" 
                                        title="Gerar Log em TXT">
                                            <font-awesome-icon
                                                :icon="['fa','file']"
                                                title="Gerar Log em TXT"
                                            />
                                            Gerar Log em TXT
                                    </b-button>
                                </b-col>
                            </b-row>                          
                            <b-card class="p-0 mt-2 col-12 logerros">                                               
                                <b-table                                                             
                                    :fields="tabelaLog.fields"                                                               
                                    :items="tabelaLog.items"  
                                    :current-page="tabelaLog.currentPage"            
                                    :per-page="tabelaLog.perPage"    
                                    responsive  
                                    small
                                    bordered              
                                    >
                                    <template v-slot:cell(mensagens)="data" >                                                                                             
                                            <a v-for="(msg, index)  in data.item.mensagens" :key="index">{{msg}}</a>                                            
                                    </template>
                                </b-table>   

                                <template v-slot:footer>
                                    <b-row>
                                        <b-col md="3" sm="12" >                    
                                            <b-form-group                       
                                                label-cols="8"
                                                label="Itens por página:"
                                                label-align="right"
                                                label-size="sm"   
                                                label-class="mt-1 text-secondary" >                                                                                                                                                                                                   
                                                <b-form-select                                
                                                    v-model="tabelaLog.perPage"
                                                    size="sm"
                                                    :options="tabelaLog.pageOptions"
                                                    @change="mudarItensPorPagina()"                            
                                                    >
                                                </b-form-select>
                                            </b-form-group> 
                                        </b-col>
                                        <b-col >
                                            <b-pagination   
                                                v-if="tabelaLog.totalRows > tabelaLog.perPage"                                                 
                                                :total-rows="tabelaLog.totalRows" 
                                                :per-page="tabelaLog.perPage" 
                                                :value="tabelaLog.currentPage"                  
                                                @change="mudarPagina" 
                                                class="mt-2 float-right" 
                                                size="sm">                    
                                            </b-pagination>
                                        </b-col>
                                    </b-row>    
                                </template>
                            </b-card>   
                        </div>                     
                    </b-card>           
                </div>                
            </div>
       </div>
    </div>
</template>

<script>
import moment from 'moment';
import FileSaver from 'file-saver';

export default {

    data() {
        return {            
                           
            arquivo: null,
            nomeArquivo: '',
            dataImportacao: null,
            texto:'',

            extPermitidasArquivo: [".xlsx"], 

            exibirResultadoImportacao: false,

            totaisRegistros: {
                numeroRegistros: 0,
                importadosComSucesso: 0,                
                erros: 0,
                semConta: 0
            },
            
            tabelaLog:{
                currentPage: 1,
                items: [],
                fields: [               
                    {
                        key: 'linha',
                        label: 'Linha do Arquivo',
                        class: 'text-center'
                    },
                    {
                        key: 'nome_completo',
                        label: 'Nome',
                        class: 'text-center'
                    },    
                    {
                        key: 'cpf_requerente',
                        label: 'CPF',
                        class: 'text-center'
                    },    
                    {
                        key: 'mensagens',
                        label: 'Mensagens',
                        class: 'text-center'
                    },                                        
                ],                
                perPage: 10,         
                totalRows: 0,
                pageOptions: [10, 25, 50],
            },    
        };
    },

    computed:{
        registroInicialPagina(){
            return ((this.tabelaLog.currentPage - 1) * this.tabelaLog.perPage) + 1;
        },

        registroFinalPagina(){
            let regFinal = this.tabelaLog.currentPage * this.tabelaLog.perPage;
            if(regFinal > this.tabelaLog.totalRows){
                regFinal = this.tabelaLog.totalRows;
            }
            return regFinal;
        }
    },


    methods: {
        inputArquivo(){                
            if(this.arquivo && !this.$helpers.validaExtensaoArquivo(this.arquivo.name, this.extPermitidasArquivo)){                
                this.$helpers.showToast(this, 'Atenção!','Extensão do arquivo não suportada. Escolha arquivos com as extensões: ' +  this.extPermitidasArquivo.toString(), 'warning');
                this.arquivo = null;
            }
        },
        
        getFormDataArquivo(arquivo){
            const formData = new FormData();   
            formData.append('arquivo', arquivo);
            formData.append('ind_abertura_conta', true);
            return formData;
        },

        importar(){
            let params = this.getFormDataArquivo(this.arquivo);    
           
                     
            this.$api.post(`importacoes/retorno-arquivos-caixa`, params)
                .then(response => {  
                    this.montarResultado(response);

                    if(this.totaisRegistros.importadosComSucesso > 0 &&  this.totaisRegistros.erros === 0){
                        this.$helpers.showToast(this, 'Sucesso', response.data.message,'success');
                    }else if(this.totaisRegistros.importadosComSucesso > 0 &&  this.totaisRegistros.erros > 0){
                        this.$helpers.showToast(this, 'Atenção!', response.data.message,'warning');
                    }   
                    
                })
                .catch(error => {   
                    if(error.response.data.dados != null){
                        if(error.response.data.dados.erros){
                            this.montarResultado(error.response);
                            this.$helpers.showToast(this, 'Erro', error.response.data.message, 'danger');
                        }                        
                    }else {
                        this.$helpers.showToast(this, 'Erro', error.response.data.message, 'danger');
                    }                                                                        
                });              
        },

        montarResultado(response){
            this.texto = "Linha do Arquivo;Nome;CPF;Mensagens"+"\n";  
            response.data.dados.erros.forEach(element => {
                this.texto += element.linha+";"+element.nome_completo+";"+element.cpf_requerente+";"+element.mensagens+ "\n";
            });
            this.tabelaLog.items = [];

            this.tabelaLog.items = response.data.dados.erros;   
            this.tabelaLog.totalRows = this.tabelaLog.items.length;
            
            this.exibirResultadoImportacao = true;
            this.nomeArquivo = this.arquivo.name;
                                
            this.dataImportacao =  moment().format('DD/MM/YYYY HH:mm:ss'); 
            this.arquivo = null;  

            this.totaisRegistros.numeroRegistros = response.data.dados.totais_registros.numero_registros;
            this.totaisRegistros.importadosComSucesso = response.data.dados.totais_registros.importados_com_sucesso;                 
            this.totaisRegistros.erros = response.data.dados.totais_registros.erros; 
            this.totaisRegistros.semConta = response.data.dados.totais_registros.numero_sem_conta;  

        },

        mudarItensPorPagina(){
            this.tabelaLog.currentPage = 1;        
        },

        mudarPagina(pagina) {
            this.tabelaLog.currentPage = pagina;            
        },

        gerarLogTXT() {
            let string =  this.texto;
            var blob = new Blob([string], {type: "text/plain;charset=utf-8"});
            FileSaver.saveAs(blob, "log_arquivo_retorno_abertura_contas_"+moment().format('DD/MM/YYYY')+".txt");
        },

    },
}

</script>

<style scoped>
    .infoImportacao .item{        
        font-size: 0.9em;   
    }

    .infoImportacao .item .label{
        font-weight: bold;        
    }

    .logerros .label{
        font-weight: bold;
    }

    .logerros .item{
        font-size: 0.9em;        
    }
</style>
